<template>
    <section class="flower-list" id="flower-list">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="title-wrap">
                        <h1>印花攻略</h1>
                        <p>活動期間：2019/4/26-5/9</p>
                    </div>
                </div>
            </div>
            <div class="row" v-if="!show_flower">
                <div class="col-12">
                    <div class="img-wrap">
                        <img src="../assets/not_show.png" alt="">
                    </div> 
                </div>
            </div>
            
            <div class="row" v-else>
                <div class="col-lg-4 col-sm-6 col-12">
                    <div class="main-wrap">
                        <div class="img-wrap">
                            <img src="../assets/flower-logos/4101每週六日.jpg" alt="">
                        </div>


                        <div class="text-wrap">
                            <h3 class="brand-name">3/15~5/9每週六日</h3>
                            <p class="text1">全店單筆每滿400元</p>
                            <p class="text2">加贈印花<span>2</span>枚</p>
                        </div>
                    </div>
                </div>
                <div v-for="(data, id) in all_datas" class="col-lg-4 col-sm-6 col-12">
                    <div class="main-wrap" @click="trigger_click(data.id)">
                        <div class="img-wrap">
                            <img :src="data.brand_img" alt="">
                        </div>


                        <div class="text-wrap">
                            <h3 class="brand-name">{{data.brand_name}}</h3>
                            <p class="text1" v-html="data.brand_text1"></p>
                            <p class="text2" v-html="addSpan(data.brand_text2)"></p>
                            <!-- <p class="text2">{{hasNumber(data.brand_text2)}}</p> -->
                            <div class="link-wrap">
                                <a :class="`flower${data.id}`" :href="`#/FlowerList/${id}`">查看詳情</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-12">
                    <div class="download-wrap">
                        <a target="_blank" class="bd-btn download-flowerlist" href="./src/assets/pxmart-printingList1123_sc9v2.pdf">下載印花清單</a>
                    </div>     
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="download-wrap">
                        <!-- <a target="_blank" class="bd-btn" href="./src/assets/pxmart-printingList1123_sc9v2.pdf">下載印花清單</a> -->
                        <a target="_blank" href="./src/assets/印花清單0426-0509.pdf" class="bd-btn download-card" @click="open_pdf">下載印花清單</a>
                    </div>     
                </div>
            </div>
        </div>
    </section>
</template>
<script>
//import first_img from "./src/assets/flower-logos/01豬事福利來.jpg";
import axios from 'axios';
export default {
    data(){
		return {
            //first_img,
			all_datas: "",
            json_src: './src/assets/json/flower-list.json',
            show_flower: true

		}
    },
    methods: {
		get_flower_datas() {
            axios.get(this.json_src).then((response) => {
                
                //console.log(response.data)
                this.all_datas = response.data;

                
                response.data.forEach((e)=>{
                    //console.log(e.id)
                    this.ga_func(".flower"+e.id, "首頁-"+e.ga_name+"-印花");
                });
	
            }, (error) => {
            	console.log(error)
            })
        },
        ga_func(class_name, name){
            $("body").on('click',class_name , function (e) {
                //alert()
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        },
        trigger_click(id){
            $(`.flower${id}`)[0].click();
        },
        addSpan(myString) {
            //return /\d/.test(myString);
            let d = myString.match(/\d+/);
            //return myString.indexOf(firstDigit);
            let nString = myString.replace(d, '<span>'+d+'</span>');
            return nString;
        },
        open_pdf(){

        }
    },
    mounted(){
        this.get_flower_datas();
        

        //download-flowerlist
        this.ga_func(".download-flowerlist", "首頁-下載印花清單");
        console.log("flowerLi!!")


        //{
		// "id": 1,
		// "nick_name": "豬事福利來",
		// "brand_name": "豬事福利來",
		// "brand_text1": "全店單筆滿600元",
		// "brand_text2": "加贈印花3枚",
		// "duration": "2019/1/18~1/24",
		// "brand_img": "./src/assets/flower-logos/01豬事福利來.jpg",
		// "products": 
		
		
	}
    
}
</script>
<style lang="sass">
*
    //border: 1px solid
@import "~styles/global.sass"
section.flower-list
    padding-top: 50px
    // margin-bottom: 100px
    // @media (max-width: 768px)
    //     margin-bottom: 50px
    .title-wrap
        margin-bottom: 70px
        @media (max-width: 768px)
            margin-bottom: 50px
        h1
            text-align: center
        p
            text-align: center
    .main-wrap
        
        padding-top: 0
        background: white
        box-shadow: 0 1px 10px rgba(black ,0.1)
        margin-bottom: 30px
        transition: .3s
        cursor: pointer
        &:hover
            background: $red
            *
                color: white
            a
                color: white !important
            .text2
                span
                    background: white
                    color: black

        .img-wrap
            // margin-left: -20px
            // margin-right: -20px
            width: 100%
            background: white
            text-align: center
            padding-top: 20px
            padding-bottom: 20px
            img
                width: 100%
                margin: 0 auto
        .text-wrap
            padding: 20px
            cursor: pointer

        h3
            font-size: 20px
            margin-bottom: 5px
        .text1
            font-weight: 300
        .text2
            span
                padding: 4px 10px
                margin: 0 5px
                display: inline-block
                border-radius: 5px
        p
            margin-bottom: 5px
        .link-wrap
            text-align: right
            position: relative
            top: -30px
            height: 0
            a
                color: black
                font-weight: 300
                text-decoration: underline
    .download-wrap
        margin-top: 80px
        margin-bottom: 80px
        @media (max-width: 576px)
            margin-top: 40px
            margin-bottom: 40px
        a
            &:hover
                color: white
    .not_show_title
        text-align: center
        font-size: 24px
    .img-wrap
        img
            width: 100%


</style>



// WEBPACK FOOTER //
// src/Index/FlowerList.vue